import { createContext, useContext } from 'react';
import type { ImportBatchRow } from '@discovr/types';

/** Pasted handles upload as a one-column sheet, so Go numbers them from row 2 (row 1 is the header the paste never showed).
 *  The review shows the number minus this offset; edits and deletes still carry Go's own number. */
export const RowNumberOffsetContext = createContext(0);

export function useRowNumberDisplay(): (rowNumber: number) => number {
  const offset = useContext(RowNumberOffsetContext);
  return (rowNumber) => rowNumber - offset;
}

const LEFT_OUT = new Set(['skip', 'keep_existing']);
const STILL_WORTH_NAMING = new Set(['', 'skipped_at_import']);

/** Handles of the rows an outreach import leaves out because the creator is already on the campaign. */
export function alreadyOnCampaignHandles(rows: ImportBatchRow[]): string[] {
  return rows
    .filter((row) => row.rosterMatch !== null && LEFT_OUT.has(row.rosterResolution) && STILL_WORTH_NAMING.has(row.dropReason))
    .map((row) => row.usernameKey);
}
